<template>
  <v-dialog v-model="mutableOpenDialog" max-width="800px">
    <v-card tile>
      <v-toolbar card dark :color="temaColor">
        <v-toolbar-title>Importar Archivo xls/xml del Catastro</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click.native="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <h2
                v-if="!FilesUpSelected"
                class="blue--text  font-weight-light pb-2"
              >
                Selecciona el Archivo xls/xml
              </h2>
              <h2 v-else class="blue--text  font-weight-light pb-2">
                {{
                  `Encontrada la Ref.: ${catastroKey} con ${numInmuebles} inmuebles`
                }}
              </h2>
              <input
                v-if="!FilesUpSelected"
                accept="application/vnd.ms-excel, text/xml"
                class="font-weight-light"
                type="file"
                @change="onFileChange"
              />
              <div v-else>
                <span>{{ FilesUpSelected.name }}</span
                ><br />
                <v-btn class="red white--text" @click="removeFile"
                  >Eliminar</v-btn
                >
                <v-btn color="blue darken-1" @click.native="submitFiles"
                  >Guardar</v-btn
                >
                <!-- <v-btn color="warning" @click.native="closeDialog">Cerrar</v-btn> -->
              </div>
            </v-flex>
            <v-flex xs12> </v-flex>
            <!-- <v-flex xs12>
                            <v-list>
                                <v-list-tile
                                    v-for="tile in FilesUpSelected"
                                    :key="tile.idx"
                                    @click="removeFile()">
                                <v-list-tile-avatar>
                                    <v-icon class="red white--text">delete_outline</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>{{ tile.name }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-flex> -->
            <v-flex xs12 v-if="FilesUpSelected">
              <template>
                <v-treeview
                  light
                  v-model="treeResult.tree"
                  :open="treeResult.open"
                  :items="treeResult.items"
                  activatable
                  item-key="name"
                  open-on-click
                >
                  <template slot="prepend" slot-scope="{ item, open }">
                    <v-icon v-if="!item.file">
                      {{ open ? "mdi-folder-open" : "mdi-folder" }}
                    </v-icon>
                    <v-icon v-else>
                      {{ treeResult.files[item.file] }}
                    </v-icon>
                  </template>
                </v-treeview>
              </template>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" @click.native="submitFiles">Subir</v-btn>
                <v-btn color="blue darken-1" flat @click.native="closeDialog">Cerrar</v-btn>
            </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["openDialog"],
  data() {
    return {
      mutableOpenDialog: false,
      FilesUpSelected: null,
      catastroKey: null,
      resultado: {},
      numInmuebles: 0,
      treeResult: {
        open: [],
        files: {
          map: "mdi-map-marker",
          sup: "mdi-domain",
          info: "mdi-information",
          data: "mdi-checkbox-multiple-marked-circle-outline",
          html: "mdi-language-html5",
          js: "mdi-nodejs",
          json: "mdi-json",
          md: "mdi-markdown",
          pdf: "mdi-file-pdf",
          png: "mdi-map-marker",
          txt: "mdi-file-document-outline",
          xls: "mdi-file-excel"
        },
        tree: [],
        items: [
          {
            name: "12345678787",
            children: [
              {
                name: "static",
                children: [
                  {
                    name: "logo.png",
                    file: "sup"
                  }
                ]
              },
              {
                name: "favicon.ico",
                file: "map"
              },
              {
                name: "index.html",
                file: "html"
              }
            ]
          }
        ]
      }
    };
  },
  watch: {
    openDialog(valor) {
      this.removeFile();
      this.mutableOpenDialog = valor;
    }
  },
  computed: {
    temaColor() {
      return this.$store.getters.getTemaColorAdminUI;
    }
  },
  methods: {
    closeDialog() {
      this.mutableOpenDialog = false;
      this.$emit("closeDialog");
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.FilesUpSelected = files[0];

      // https://www.desarrollolibre.net/blog/javascript/la-api-de-archivos-en-javascript-accediendo-al-contenido#.W87c01Uzaa5
      // Verifica la lectura de archivos desde el navegador
      if (!window.File) {
        alert("La API File no está soportada");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = this.onFileLoaded;
      reader.readAsText(this.FilesUpSelected, "utf8");

      /* for (let index = 0; index < this.FilesUpSelected.length; index++) {
                const element = this.FilesUpSelected[index];
                // eslint-disable-next-line
                console.log(element.name)
            } */
    },
    onFileLoaded(event) {
      const xml = event.currentTarget.result;
      const xmlDOM = new DOMParser().parseFromString(xml, "text/xml");
      const urbano = xmlDOM.getElementsByTagName("Worksheet")[0];
      const rows = urbano.getElementsByTagName("Row");
      console.log(`rows: ${rows.length}`);
      let parcial = {};
      let direccion = "";
      this.treeResult.items = [
        {
          name: "",
          children: []
        }
      ];
      // this.treeResult.items[0].children = []
      for (let index = rows.length - 1; index > 2; index--) {
        const data = rows[index].getElementsByTagName("Data");
        // console.log(data);
        const key = this.valorCell(data[0]).substr(14, 4);
        parcial[key] = {
          refCat: this.valorCell(data[0]),
          direccion: this.valorCell(data[1]),
          uso: this.valorCell(data[2]),
          superficie: this.valorCell(data[3]),
          year: this.valorCell(data[4]),
          cuota: this.valorCell(data[5])
        };

        const child = [
          {
            name: `Ref.: ${this.valorCell(data[0])}`,
            file: "info"
          },
          {
            name: `Dirección: ${this.valorCell(data[1])}`,
            file: "map"
          },
          {
            name: `Uso: ${this.valorCell(data[2])}`,
            file: "data"
          },
          {
            name: `Superficie: ${this.valorCell(data[3])}`,
            file: "data"
          },
          {
            name: `Antigüedad: ${this.valorCell(data[4])}`,
            file: "data"
          },
          {
            name: `Cuota: ${this.valorCell(data[5])}`,
            file: "data"
          }
        ];
        this.treeResult.items[0].children.push({
          name: key,
          children: child
        });

        if (!this.catastroKey) {
          direccion = this.valorCell(data[1]);
          this.catastroKey = this.valorCell(data[0]).substr(0, 14);
          this.treeResult.items[0].name = `${this.valorCell(data[0]).substr(
            0,
            14
          )}  >>  (${rows.length - 3})`;
          this.treeResult.open = [this.valorCell(data[0]).substr(0, 14), key];
        }
      }
      // this.resultado[this.catastroKey] = parcial
      this.resultado["inmuebles"] = parcial;
      this.resultado["idx"] = this.catastroKey;
      this.numInmuebles = rows.length - 3;

      const resultEmit = {
        idx: this.catastroKey,
        numInmuebles: this.numInmuebles,
        direccion: direccion
      };
      this.$emit("resultado", resultEmit);
    },
    valorCell(cell) {
      return cell.textContent.trim();
    },
    removeFile() {
      this.FilesUpSelected = null;
      this.catastroKey = null;
      this.numInmuebles = 0;
      this.resultado = {};
      /* // eslint-disable-next-line
            console.log(idx)
            let result = []
            for (let index = 0; index < this.FilesUpSelected.length; index++) {
                const element = this.FilesUpSelected[index]
                if (index !== idx) {
                    result.push(element)
                }   
            }
            this.FilesUpSelected = result */
      /* let elements = this.FilesUpSelected
            elements.splice(idx, 1)
            this.FilesUpSelected = elements */
    },
    submitFiles() {
      if (!this.catastroKey || !this.resultado) {
        return;
      }
      // Guardar en 'newCatastro' (READ only)
      this.$store.dispatch("updateNewCatastroInmuebles", this.resultado);

      // Verificar antes de guardar en 'castastro' (READ / WRITE)
      const existe = this.$store.getters.getCatastroId(this.catastroKey);
      if (existe) {
        if (
          !confirm(
            `Existen datos la tabla catastro ${
              this.catastroKey
            }. ¿Quieres reemplazarlos?`
          )
        ) {
          return;
        }
      }
      this.$store.dispatch("updateCatastroInmuebles", this.resultado);
    }
  }
};
</script>
